<span class="checkin__booking__detail__dates__item__slug">{{ date?.slug | translate }}</span>
<ng-container *ngIf="customTemplate">
    <ng-container *ngTemplateOutlet='customTemplate'></ng-container>
</ng-container>

<ng-container *ngIf="!customTemplate">
    <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
</ng-container>

<ng-template #chineseTemplate>
    <span class="checkin__booking__detail__dates__item__date">{{ date?.date }}</span>
    <span class="checkin__booking__detail__dates__item__day">{{ date?.day }}</span>
</ng-template>

<ng-template #englishUSTemplate>
    <span class="checkin__booking__detail__dates__item__day">{{ date?.monthDay }}</span>
    <span class="checkin__booking__detail__dates__item__date">{{ date?.year }}</span>
</ng-template>

<ng-template #defaultTemplate>
    <span class="checkin__booking__detail__dates__item__day">{{ date?.day }}</span>
    <span class="checkin__booking__detail__dates__item__date">{{ date?.date }}</span>
</ng-template>
